<template>
  <div class="rounded border-gpx_gray-700 bg-gpx_gray-900 px-4 py-3">
    <b class="text-gpx_slate-300">{{ props.description }}</b>
    <i class="text-[14px]"> ( {{ happenedAt }} ) </i>
  </div>
</template>

<script setup>
import * as _ from 'lodash';
import { computed } from 'vue';
import { formatTime } from '@/filters';

const props = defineProps({
  description: {
    type: String,
    required: true,
  },
  date: {
    type: String,
    required: true,
  },
});

const happenedAt = computed(() => {
  if (_.isNull(props.date)) return '-';
  return formatTime(props.date, 'MMM d, yyyy h:mm aa');
});
</script>
